import React, { memo } from "react";
import { FaPlus, FaTasks } from "react-icons/fa";
import { Handle } from "reactflow";

import "./index.css";
import { ValidatorFn } from "../../../helpers/validationConnector";
import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

export default memo(({ data, ...rest }) => {
	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle type="target" position="left" isConnectable={true} isConnectableStart={false} />

			<NodeHeader
				rest={rest}
				data={data}
				icon={<FaTasks />}
				text="Criar tarefa"
			/>

			{data?.objectData?.name && (
				<div className="sendMessageContent">
					<div>{data?.objectData?.name}</div>
				</div>
			)}

			<Handle
				type="source"
				position="right"
				className="handle"
				isConnectable={true}
				isValidConnection={ValidatorFn()}
			>
				<FaPlus size={8} style={{ pointerEvents: "none" }} />
			</Handle>
		</>
	);
});
